import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalCase' })
export class CapitalCasePipe implements PipeTransform {

  transform(value: string | null | undefined, _args?: unknown): string {
    return (value) ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : '';

  }
}
